import { twMerge } from 'utilities/src/twMerge';
import React from 'react';
import Link from 'next/link';
import useBreadcrumbsTheme from './themes';

interface ItemConditionalWrapperProps extends React.HTMLAttributes<HTMLElement> {
  href?: string;
  children: React.ReactElement;
}

export default function ItemConditionalWrapper({ href, children, ...props }: ItemConditionalWrapperProps) {
  const { linkVariantClasses, breadcrumbLinkOpt } = useBreadcrumbsTheme();

  if (!href) return React.cloneElement(children, { ...props, ...children.props });

  return (
    <Link href={href} {...props} className={twMerge(linkVariantClasses, breadcrumbLinkOpt, props.className)}>
      {children}
    </Link>
  );
}
